
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DialogHeader, DialogFooter, Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { FbPage } from "@/types/fb-type";
import { FacebookIcon, ExternalLink } from "lucide-react";
import { useState } from "react";
import { refeshConfig, whiteListDomain } from "@/api/fbapi";
import { toast } from "@/hooks/use-toast";
import { navigate } from "wouter/use-browser-location";
import { Button } from "../ui/button";
import ConnectedPageCard from "./ConnectPageCard";
type SettingFacebookPageCardProps = {
    currentPage?: FbPage | null;

}
export function SettingFacebookPageCard({ currentPage }: SettingFacebookPageCardProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const reconnectFacebook = async () => {
        const refreshResponse = await refeshConfig();
        if (refreshResponse.success) {
            toast({ title: "Success", description: "Refresh configurtion done!" });
            setTimeout(() => {
                navigate("/fblogin"); // redirect to fblogin
            }, 1000);
        } else {
            toast({
                title: "Error",
                description:
                    refreshResponse.message || "Unexpected error refresh config",
                variant: "destructive",
            });
        }
    };
    const doWhiteListDomain = async () => {
        const response = await whiteListDomain();
        if (response.success) {
            toast({ title: "Success", description: "White list domain done!" });
        } else {
            toast({
                title: "Error",
                description:
                    response.message || "Unexpected error white list domain",
                variant: "destructive",
            });
        }
    };

    return <>
        <Card>
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    Your Facebook Page {currentPage && ` : ${currentPage.pageName}`}
                    {currentPage && (
                        <a
                            href={`https://facebook.com/${currentPage.pageId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-muted-foreground hover:text-primary transition-colors"
                            title="Open in Facebook"
                        >
                            <ExternalLink className="h-4 w-4" />
                        </a>
                    )}

                    {/* {currentPage && (
                        <Button
                            variant="outline"
                            onClick={doWhiteListDomain}
                        >
                            White List Domain
                        </Button>
                    )} */}
                </CardTitle>
            </CardHeader>
            {currentPage && (
                <CardContent>
                    <ConnectedPageCard currentPage={currentPage} setIsOpen={setIsOpen} />
                    <div>
                        <Dialog open={isOpen} onOpenChange={setIsOpen}>
                            <DialogContent className="max-w-2xl">
                                <DialogHeader>
                                    <DialogTitle>
                                        Re-Connect Facebook Page Again?{" "}
                                    </DialogTitle>
                                    <DialogDescription>
                                        Re Connect Page will Impact Current Page Information
                                        and Integration
                                    </DialogDescription>
                                </DialogHeader>

                                <DialogFooter className="flex-col sm:flex-row gap-2">
                                    <div className="flex gap-2">
                                        <Button
                                            variant="outline"
                                            onClick={() => setIsOpen(false)}
                                        >
                                            Cancel
                                        </Button>
                                        <Button onClick={reconnectFacebook} className="gap-2">
                                            Confirm
                                        </Button>
                                    </div>
                                </DialogFooter>
                            </DialogContent>
                        </Dialog>
                    </div>
                </CardContent>
            )}
            {!currentPage && (
                <CardContent>
                    <div className="text-center py-8">
                        <div className="mx-auto h-16 w-16 text-gray-400 mb-4">
                            <i className="fas fa-university text-4xl"></i>
                        </div>
                        <h3 className="text-lg font-medium text-gray-900">
                            No Facebook Page configured
                        </h3>
                        <p className="text-gray-500 mt-2 max-w-md mx-auto">
                            Add your facebook page to process automate order management.
                        </p>
                        <Button className="mt-4" onClick={reconnectFacebook}>
                            Add Facebook Page
                        </Button>
                    </div>
                </CardContent>
            )}
        </Card></>
}